import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { JourneyDistrictReportData } from '@mira-avant/mtlibs';
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
	selector: 'app-journey-district-report-summary',
	imports: [CommonModule, NzButtonModule, NzIconModule],
	standalone: true,
	templateUrl: './journey-district-report-summary.html',
	styleUrl: './journey-district-report-summary.scss',
})
export class JourneyDistrictReportSummary {
	@Input('report') public report:JourneyDistrictReportData | undefined;
}
